import { ABP, ListService, PagedResultDto, TrackByService } from '@abp/ng.core';
import { DateAdapter } from '@abp/ng.theme.shared/extensions';
import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';

import type {
  EquipmentDto,
} from '../../../../proxy/equipments/models';
import { EquipmentService } from '../../../../proxy/equipments/equipment.service';
import { AssetService } from '../../../../proxy/assets';
import { AssetWithNavigationPropertiesDto, GetAssetsInput } from '../../../../proxy/assets/models';
import { AssetComponent } from '../../../../assets/asset/components/asset.component';
import { EquipmentDtoEmpty } from '../../../../proxy/equipments/emptys-dto';

@Component({
  selector: 'app-equipment-details',
  providers: [ListService, { provide: NgbDateAdapter, useClass: DateAdapter }],
  templateUrl: './equipment-details.component.html',
  styleUrls: []
})
export class EquipmentDetailsComponent implements OnInit {
  isEquipmentInfoHidden = true;

  equipment: EquipmentDto;

  dataAssets: PagedResultDto<AssetWithNavigationPropertiesDto> = {
    items: [],
    totalCount: 0,
  };

  filtersAsset = {} as GetAssetsInput;

  @ViewChild(AssetComponent) assetComponent: AssetComponent; 

  isFiltersAssetHidden = true;

  constructor(
    public readonly list: ListService,
    public readonly track: TrackByService,
    public readonly service: EquipmentService,
    public readonly serviceAsset: AssetService,
    private route: ActivatedRoute,
  ) {
    this.equipment = new EquipmentDtoEmpty;
  }

  ngOnInit(): void {
    var equipmentId = this.route.snapshot.paramMap.get('id');
    this.service.get(equipmentId).subscribe(result => this.loadEquipment(result));
  }

  loadEquipment(equipment: EquipmentDto){
    this.equipment = equipment;
    this.assetComponent.setEquipment(equipment);
  }

}
